import { ConnectClient } from '@kiddocaremy/sdk-ts'

/**
 * Shared SDK ConnectClient instance
 *
 * Single source of truth for the SDK client used across the entire application.
 * This instance is shared by all stores, services, and composables.
 *
 * Configuration:
 * - baseURL: API base URL from environment variable
 * - cdnURL: CDN base URL for static resources
 *
 * @example
 * ```typescript
 * import { sdk } from '@/lib/sdk'
 *
 * // Use in any store, service, or composable
 * const response = await sdk.general.init(Platform.ID_CONNECT)
 * const resources = await sdk.staticData.getResources(hash)
 * ```
 */
export const sdk = new ConnectClient({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    cdnURL: import.meta.env.VITE_CDN_BASE_URL,
    // Default is 30s; multipart photo uploads (centre media step) can exceed
    // that on slow mobile connections, so allow more headroom before aborting.
    timeout: 120000
})
